export const PXFeaturedCallout = (function() {
	'use strict';

	var $callouts;

	function init() {

		// show a random feature
		$callouts = $('.portrait__option');
		// console.log($callouts.length);
		$callouts.eq(Math.floor($callouts.length * Math.random())).show();

		// events();
	}

	function events() {}

	return {
		init: init
	};
})();
